<template>
  <section></section>
</template>

<script>
export default {
    name: 'DonationCallback'
}
</script>

<style scoped>

</style>